export default {
  title: 'Dostawcy dostaw',
};
